import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=07438621&"
import script from "./BaseTable.vue?vue&type=script&lang=js&"
export * from "./BaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports